import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const UtilitiesPage: React.FC = () => {
  const { t } = useTranslation();

  const useCases = [
    {
      icon: 'fas fa-shield-alt',
      key: 'savings'
    },
    {
      icon: 'fas fa-shopping-bag',
      key: 'shopping'
    },
    {
      icon: 'fas fa-chart-line',
      key: 'trading'
    },
    {
      icon: 'fas fa-tools',
      key: 'tools'
    }
  ];

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="floating-element"></div>
        <div className="floating-element"></div>
        <div className="floating-element"></div>
      </div>

      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="hero-background absolute inset-0">
          <div
            className="absolute inset-0 opacity-30"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='grid' width='100' height='100' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 100 0 L 0 0 0 100' fill='none' stroke='rgba(212, 175, 55, 0.1)' stroke-width='1'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='100%25' height='100%25' fill='url(%23grid)' /%3E%3C/svg%3E")`,
            }}
          />
        </div>

        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
          <div className="hero-badge inline-block px-4 py-2 bg-gold/10 rounded-full mb-6">
            <span className="text-gold font-semibold text-sm uppercase tracking-wider">
              {t('useCases.eyebrow')}
            </span>
          </div>
          <h1 className="text-4xl md:text-6xl font-black text-white mb-8 leading-tight bg-gradient-to-r from-gold to-gold-light bg-clip-text text-transparent">
            {t('useCases.title')}
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
            {t('useCases.description')}
          </p>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="section relative">
        <div className="container">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {useCases.map((useCase, index) => (
              <div key={index} className="modern-card group text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-gold/20 to-gold/5 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${useCase.icon} text-4xl text-gold`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-gold transition-colors">
                  {t(`useCases.${useCase.key}.title`)}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {t(`useCases.${useCase.key}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section relative bg-bg-secondary/50">
        <div className="container">
          <div className="cta-section relative max-w-4xl mx-auto text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-gold/20 to-gold/5 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="fas fa-rocket text-4xl text-gold"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-white mb-6">
              {t('utilities.cta.title')}
            </h2>
            <p className="text-xl text-gray-400 mb-8 max-w-2xl mx-auto">
              {t('utilities.cta.description')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/buy">
                <button className="group relative overflow-hidden px-8 py-4 text-lg font-bold bg-gradient-to-r from-gold to-gold-light text-black rounded-full hover:from-gold-light hover:to-gold transition-all duration-300">
                  <span className="relative z-10 flex items-center justify-center">
                    <i className="fas fa-shopping-cart mr-3"></i>
                    {t('utilities.cta.startTrading')}
                  </span>
                </button>
              </Link>
              <Link to="/redemption">
                <button className="group relative overflow-hidden px-8 py-4 text-lg font-bold bg-white/10 text-white rounded-full hover:bg-white/20 transition-all duration-300 border border-gold/30">
                  <span className="relative z-10 flex items-center justify-center">
                    <i className="fas fa-coins mr-3"></i>
                    {t('utilities.cta.exploreNFTs')}
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
